import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-new-version',
  templateUrl: './new-version.component.html',
  styleUrls: ['./new-version.component.scss'],
  standalone: false
})
export class NewVersionComponent {
  constructor(
    public activeModal: NgbActiveModal,
    public themeService: ThemeService
  ) {}
}

LightningModalTypes.NewVersion.component = NewVersionComponent;
